const training5s = [
  {
    id: 1,
    img: "https://i.ibb.co/1fNFs30g/2-days-long-training-Advance-5-S-and-Kaizen-Training-at-Epic-Group.jpg",
    companyName: "2 days long Advance 5S and Kaizen Training at Epic Group",
  },
  {
    id: 2,
    img: "https://i.ibb.co/7x98yNDf/5-S-with-Confidence-Steel-Ltd-and-Confidence-Group.jpg",
    companyName: "5S  with Confidence Steel Ltd and Confidence Group",
  },
  {
    id: 3,
    img: "https://i.ibb.co/YFWBg9tT/5s-Visual-Management-with-Top-Leaders-at-Epyllion-Group.jpg",
    companyName: "5s & Visual Management  with Top Leaders at Epyllion Group",
  },
  {
    id: 4,
    img: "https://i.ibb.co/Zk5N4QP/5s-Training-pharma-Compnay.jpg",
    companyName: "5s at a Office Floor",
  },
  {
    id: 5,
    img: "https://i.ibb.co/g183fwb/5s-visual-managment-at-Appral-Industry.jpg",
    companyName: "5s & visual managment at Appral Industry",
  },
  {
    id: 6,
    img: "https://i.ibb.co/XZP1Fykp/5-S-and-Kaizen-Session-at-Feni-Lanka-Power-Limited.jpg",
    companyName: "5S and Kaizen Session at Feni Lanka Power Limited",
  },
  // {
  //   id: 7,
  //   img: "https://i.ibb.co/TDJnhg0H/5-S-and-Safety-Training-at-Myth-Group.jpg",
  //   companyName: "5S and Safety Training at Myth Group",
  // },
  {
    id: 8,
    img: "https://i.ibb.co/qMR2fYK0/Workplace-Organization-Through-5-S-with-Multinational-Power-Generation-Company.jpg",
    companyName:
      "Workplace Organization Through 5S with Multinational Power Generation Company",
  },
  // {
  //   id: 9,
  //   img: "https://i.ibb.co/bMkxqhVc/Workplace-Organization-Through-5-S-with-Multinational-Power-Generation-Company.jpg",
  //   companyName:
  //     "Workplace Organization Through 5S at Multinational Power Generation Company",
  // },
  {
    id: 10,
    img: "https://i.ibb.co/7NZNk4PG/5s-Kaizen-at-Confidence-Steel-Ltd.jpg",
    companyName: "5s & Kaizen at Confidence Steel Ltd",
  },
  {
    id: 11,
    img: "https://i.ibb.co/602rYc84/5-S-and-Visual-Management-at-Crystal-Group.jpg",
    companyName: "5S and Visual Management at Crystal Group",
  },
  {
    id: 12,
    img: "https://i.ibb.co/Kpy63TqX/Office-5-S-Greater-Efficiency-at-Business-Process-at-IL-Bangladesh-and-Renaissance-Group.jpg",
    companyName:
      "5S Training for Efficiency at Business Process at Interloop Bangladesh",
  },
  {
    id: 13,
    img: "https://i.ibb.co/VbPH3GM/5s-at-the-Store-of-a-Heavy-Industry.jpg",
    companyName: "5s at the Store of a Heavy Industry",
  },
  {
    id: 14,
    img: "https://i.ibb.co/cKWCSrbh/Plant-Wide-5s-at-Confidence-Batteries-Ltd.jpg",
    companyName: "Plant Wide 5s at Confidence Batteries Ltd",
  },
  {
    id: 15,
    img: "https://i.ibb.co/HD0mN1fr/5-S-at-Factory-office-Floor.jpg",
    companyName: "5S at Factory office Floor",
  },
  {
    id: 16,
    img: "https://i.ibb.co/Zzp5cj3s/5s-at-the-Corporate-office-of-Large-Business-Conglomerate.jpg",
    companyName: "5s at the Corporate office of Large Business Conglomerate",
  },
  {
    id: 17,
    img: "https://i.ibb.co/MxGP4qkZ/5s-at-a-Mechanical-Workshop.jpg",
    companyName: "5s at a Mechanical Workshop",
  },
];

export default training5s;
